import api from './api'
import { Language } from '../lib/types'
import { Gender, InvestorLevel } from '../lib/types/Hubspot/Newsletter'

export type NewsletterSubscriptionPayload = {
  email: string
  language: Language
  investorLevel?: InvestorLevel
  estimatedInvestmentAmount?: number
  estimatedInvestmentHorizon?: number
  age?: number
  gender?: Gender
  note?: string
}

const HubspotService = {
  async newsletterSubscription(
    payload: NewsletterSubscriptionPayload,
  ): Promise<void> {
    await api.post('/v1/hubspot/newsletter-subscription', payload)
  },
}

export default HubspotService
